import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {
    Breadcrumb,
    Button,
    Card,
    Col, DatePicker,
    Form,
    Input,
    InputNumber,
    message,
    Radio,
    Row,
    Select,
    Space, Switch, Tooltip,
} from "antd";
import {
    FileDoneOutlined,
    LeftCircleOutlined, QuestionCircleOutlined
} from "@ant-design/icons";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import Style from "./Detail.module.css";
import TextArea from "antd/lib/input/TextArea";

const GoodsDetail = (props) => {
    const store = useSelector((store) => store);
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isSave, setIsSave] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [systemVersion, setSystemVersion] = useState(0);
    const [activityList,setActivityList] = useState([]);
    const [couponType,setCouponType] = useState("T1");//默认兑换券
    const [faceValue,setFaceValue] = useState(0);//减多少钱
    const [fullValue,setFullValue] = useState(0);//满多少
    const [discountRate,setDiscountRate] = useState(9.9);//折扣,如8折写80
    const [facePoints,setFacePoints] = useState(0);//减多少点
    const [fullPoints,setFullPoints] = useState(0);//满多少点
    const [exDays,setExDays] = useState(7)// 多少天可用

    useEffect(() => {
        if (store.main.userName) {
            ChuangShiOS.Notification.emit("main_menu_active", {url: "/coupon/index"});
            ChuangShiOS.Notification.emit("main_scroll_top", {top: 0});

            switch (props.match.path) {
                case "/coupon/add":
                    setIsSave(true);
                    handleLoadActivity();
                    form.setFieldValue("type",couponType)
                    form.setFieldValue("exType","E1") // 默认任意时段可用
                    break;
                case "/coupon/info/:id":
                    setIsEdit(true);
                    handleLoad();
                    break;
                default:
                    break;
            }
        }
        //eslint-disable-next-line
    }, [store.main.userName]);

    const handleLoadActivity = () => {
        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/activity/business/website/v1/select/list",
            data: {},
            success: (response) => {
                setActivityList(response.data);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {},
        });
    };


    const handleLoad = () => {
        if (request.current) {
            return;
        }
        request.current = true;
        setIsLoad(true);
        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/goods/business/website/v1/find",
            data: {
                goodsId: props.match.params.goodsId,
            },
            success: (response) => {
                form.setFieldsValue(response.data);
                setSystemVersion(response.data.systemVersion);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;
                setIsLoad(false);
                if(isEdit){
                    setIsError(typeof response.data == "undefined" || typeof response.data.id == "undefined" || response.data.goodsId == null);
                }
            },
        });
    };

    const handleSubmit = () => {
        if (request.current) {
            return;
        }

        form.validateFields()
            .then((data) => {
                if (request.current) {
                    return;
                }
                request.current = true;
                setIsLoad(true);
                message.loading({
                    content: "正在加载",
                    key: "isLoad",
                    duration: 0,
                });
                data.id = props.match.params.id;
                data.systemVersion = systemVersion;
                data.exDays = exDays;
                data.fullValue = fullValue;
                data.faceValue = faceValue;
                data.discountRate = discountRate;
                data.fullPoints = fullPoints;
                data.facePoints = facePoints;
                data.ebTime = (data.expTime[0]).format("YYYYMMDDHHmmss");
                data.epTime = (data.expTime[1]).format("YYYYMMDDHHmmss");
                data.expTime = undefined;

                let url = "";
                if (isSave) {
                    url = "/windeal/coupon/business/website/v1/save";
                }
                if (!url){
                    console.error("url=''")
                    return;
                }
                console.log(url)
                console.log(data)
                /*message.success({
                    content: "ok",
                    key: "isLoad",
                    duration: 2,
                });
                request.current = false;
                setIsLoad(false);
                return;
                */

                ChuangShiOS.Util.request(props, {
                    url: Application.host + url,
                    data: data,
                    success: (response) => {
                        message.success({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });
                        request.current = false;
                        setIsLoad(false);
                        ChuangShiOS.Util.navigateBack(props, {});
                    },
                    error: (response) => {
                        message.error({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });
                        request.current = false;
                        setIsLoad(false);
                    },
                    complete: (response) => { },
                });
            })
            .catch((response) => {
                ChuangShiOS.Util.parseResponseError(response);
            });
    };

    const handleBack = () => {
        ChuangShiOS.Util.navigateBack(props, {});
    };

    return (
        <div className={Style.page}>
            <div className={Style.header}>
                <div className={Style.header_title}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>首页</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{store.main.menuName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className={Style.header_title_text}>{store.main.sidebarName}</div>
                </div>
                <div className={Style.header_button}>
                    <Space>
                        <Button.Group>
                            <Button icon={<LeftCircleOutlined/>} size="large" onClick={handleBack}>
                                返回
                            </Button>
                        </Button.Group>
                        <Button
                            loading={isLoad}
                            disabled={isError}
                            icon={<FileDoneOutlined/>}
                            type="primary"
                            size="large"
                            onClick={handleSubmit}
                        >
                            提交
                        </Button>
                    </Space>
                </div>
            </div>
            <ChuangShiOS.Content
                className={Style.content}
                isLoad={isLoad}
                isEmpty={false}
                isError={isError}
                paddingTop={0}
                paddingRight={0}
                paddingBottom={0}
                paddingLeft={0}
                isScroll={store.main.isFixedContent}
            >
                <Card>
                    <Row>
                        <Col flex="auto">
                            <div className={Style.card_title}>基本信息</div>
                        </Col>
                    </Row>
                    <Form form={form}>
                       { <React.Fragment>
                        <Row>
                            <Col span={12}>
                                <Form.Item
                                    {...{
                                        labelCol: {flex: "24%"},
                                        wrapperCol: {flex: "auto"},
                                    }}
                                    label="采购商活动"
                                    name="activityId"
                                    rules={[
                                        {
                                            required: true,
                                            message: "请选择采购商活动",
                                        },
                                    ]}
                                >
                                    <Select
                                        className={Style.card_field}
                                        placeholder="请选择活动"
                                        allowClear>
                                        {activityList.map((activity, activityIndex) => {
                                            return (
                                                <Select.Option key={activityIndex} value={activity.activityId}>
                                                    {activity.activityName}
                                                </Select.Option>
                                            );
                                        })}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                           <Row>
                               <Col span={12}>
                                   <Form.Item
                                       {...{
                                           labelCol: {flex: "24%"},
                                           wrapperCol: {flex: "auto"},
                                       }}
                                       label="优惠券名称"
                                       name="couponName"
                                       initialValue={""}
                                       rules={[
                                           {
                                               required: true,
                                               message: "优惠券名称",
                                           },
                                       ]}
                                   >
                                       <Input className={Style.card_field} placeholder="请输入商品名称"
                                              onPressEnter={handleSubmit}/>
                                   </Form.Item>
                               </Col>
                           </Row>
                           <Row>
                               <Col span={24}>
                                   <Form.Item
                                       {...{
                                           labelCol: {flex: "12%"},
                                           wrapperCol: {flex: "auto"},
                                       }}
                                       label="优惠券类型"
                                       name="type"
                                       rules={[
                                           {
                                               required: true,
                                               message: "请选择优惠券类型",
                                           },
                                       ]}
                                   >
                                       <Radio.Group onChange={(e)=>setCouponType(e.target.value)}>
                                           <Radio value={"T1"}>兑换券</Radio>
                                           <Radio value={"T2"}>满减券</Radio>
                                           <Radio value={"T3"}>满折券</Radio>
                                       </Radio.Group>
                                   </Form.Item>
                               </Col>
                           </Row>
                           { couponType==="T2"||couponType==="T3"?(
                               <Row>
                                   <Col span={24} style={{paddingLeft:"12%",marginBottom:"24px"}}>
                                       <Space direction="vertical">
                                           { couponType==="T2"?(<div><Space>满<InputNumber min={0} max={9999} prefix="¥" value={fullValue} onChange={(e)=>setFullValue(e)}></InputNumber>元， 减<InputNumber min={0} max={9999} prefix="¥" value={faceValue} onChange={(e)=>setFaceValue(e)}></InputNumber>元</Space></div>):null }
                                           { couponType==="T2"?(<div><Space>满<InputNumber min={0} max={9999} prefix="" value={fullPoints} onChange={(e)=>setFullPoints(e)}></InputNumber>点， 减<InputNumber min={0} max={9999} prefix="" value={facePoints} onChange={(e)=>setFacePoints(e)}></InputNumber>点</Space></div>):null }
                                           { couponType==="T3"?(<div><Space>满<InputNumber min={0} max={9999} prefix="¥" value={fullValue} onChange={(e)=>setFullValue(e)}></InputNumber>元， 打<InputNumber min={0} max={10}  value={discountRate} onChange={(e)=>setDiscountRate(e)}></InputNumber>折</Space></div>):null }
                                       </Space>
                                   </Col>
                               </Row>
                           ):null}
                           { couponType==="T2"?(
                               <Row>
                                   <Col span={12}>
                                       <Form.Item
                                           {...{
                                               labelCol: {flex: "24%"},
                                               wrapperCol: {flex: "auto"},
                                           }}
                                           label="开启券余额"
                                           name="balanceFlag"
                                           initialValue={false}
                                           valuePropName="checked"
                                           rules={[
                                               {
                                                   required: true,
                                                   message: "券余额设置不能为空",
                                               },
                                           ]}
                                       >
                                           <Switch
                                               checkedChildren="开启"
                                               unCheckedChildren="关闭"
                                               onChange={(v)=>{form.setFieldValue("balanceFlag",v)}}
                                           />
                                           &nbsp;&nbsp;&nbsp;&nbsp;
                                           <Tooltip title="开启券余额，一张券有效期内支持多次使用抵扣，一般用于优惠金额比订单金额大的场景。"  placement="topLeft">
                                               <QuestionCircleOutlined style={{fontSize:'16px'}} />
                                           </Tooltip>
                                       </Form.Item>
                                   </Col>
                               </Row>
                           ):null}
                        <Row>
                            <Col span={12}>
                                <Form.Item
                                    {...{
                                        labelCol: {flex: "24%"},
                                        wrapperCol: {flex: "auto"},
                                    }}
                                    label="券码有效期"
                                    name="expTime"
                                    rules={[
                                        {
                                            required: true,
                                            message: "请选择有效期",
                                        },
                                    ]}
                                >
                                    <DatePicker.RangePicker className={Style.card_field}
                                                 format="YYYY-MM-DD HH:mm:ss"
                                                 showTime />
                                </Form.Item>
                            </Col>
                            <Col span={8}></Col>
                        </Row>
                        <Row>
                            <Col span={24} style={{paddingLeft:"12%"}}>
                                <Form.Item name="exType">
                                    <Radio.Group>
                                        <Space direction="vertical">
                                            <Radio value={"E1"}>有效期内，任意时段可用</Radio>
                                            <Radio value={"E2"}><Space>有效期内，用户领取后<InputNumber style={{width:"60px"}} min={1} max={9999} value={exDays} onChange={(e)=>{setExDays(e)}}></InputNumber>天可用。无论何时领取，在有效期结束后不可用</Space></Radio>
                                        </Space>
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12}>
                                <Form.Item
                                    {...{
                                        labelCol: {flex: "24%"},
                                        wrapperCol: {flex: "auto"},
                                    }}
                                    label="券发行数量"
                                    name="quantity"
                                    rules={[
                                        {
                                            required: true,
                                            message: "请输入发行数量",
                                        },
                                    ]}
                                >
                                    <InputNumber
                                        className={Style.card_field}
                                        min={1}
                                        max={10000}
                                        placeholder="请输入发行数量"
                                        onPressEnter={handleSubmit}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                           <Row>
                               <Col span={12}>
                                   <Form.Item
                                       {...{
                                           labelCol: {flex: "24%"},
                                           wrapperCol: {flex: "auto"},
                                       }}
                                       label="优惠券简介"
                                       name="explain"
                                       rules={[
                                           {
                                               required: false,
                                               message: "请输入简介",
                                           },
                                       ]}
                                   >
                                       <TextArea
                                           className={Style.card_field}
                                           placeholder="请输入简介"
                                           onPressEnter={handleSubmit}
                                       />
                                   </Form.Item>
                               </Col>
                           </Row>
                       </React.Fragment>}
                    </Form>
                </Card>
            </ChuangShiOS.Content>
            <div className={Style.footer}></div>
        </div>
    );
};

GoodsDetail.propTypes = {};

GoodsDetail.defaultProps = {};

export default GoodsDetail;
